import n from '../../../../../../external/rollup-plugin-styles/dist/runtime/inject-css.js';
var css = ".monaco-link{color:var(--vscode-textLink-foreground)}.monaco-link:hover{color:var(--vscode-textLink-activeForeground)}";
n(css,{});
export { css, css as default };
